import { createApiClient } from "@jod/api-client";
import { getAuthToken } from "./auth-token.ts";
import { apiMode, assertBackendModeReady, env } from "./env.ts";

assertBackendModeReady(apiMode);

/** Shared, type-safe API client bound to the configured base URL + LINE token. */
export const api = createApiClient({
  baseUrl: env.apiBaseUrl,
  getAuthToken,
});

const DEFAULT_DEV_LINE_USER_ID = "Useed0000000000000000000000000001";
const DEV_LINE_USER_STORAGE_KEY = "jod.dev.line-user-id";

api.use({
  async onRequest({ request }) {
    if (env.isDev) {
      // Local Rust API slices currently accept explicit dev headers only when
      // `allow_dev_auth_headers` is enabled. Production builds omit these and
      // rely on server-side LINE token verification (ADR-0005).
      // localStorage override lets QA drive a second identity (e.g. the gift
      // recipient) in another browser profile/tab during local UAT.
      const override = window.localStorage.getItem(DEV_LINE_USER_STORAGE_KEY);
      request.headers.set("x-dev-line-user-id", override ?? DEFAULT_DEV_LINE_USER_ID);
    }
    return request;
  },
});
